import { MapboxGeoJSONFeature } from 'mapbox-gl'
import { createContext } from 'react'

interface LayerInteractionContextProps {
  clickedFeatures?: MapboxGeoJSONFeature[]
  setClickedFeatures: (features?: MapboxGeoJSONFeature[]) => void
  hoverFeatures?: MapboxGeoJSONFeature[]
  setHoverFeatures: (features?: MapboxGeoJSONFeature[]) => void
  dwellFeature?: any
  setDwellFeature: (feature: any) => void
}

export const LayerInteractionContext = createContext<LayerInteractionContextProps>({
  setClickedFeatures: () => null,
  setHoverFeatures: () => null,
  setDwellFeature: () => null,
})
LayerInteractionContext.displayName = 'LayerInteractionContext'
